var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.partidos),function(match){return _c('li',{key:match.id,staticClass:"contenedor-tarjetas"},[_c('TarjetaPartido',{attrs:{"partido":match},on:{"goDetail":_vm.propagateGoDetail}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }